<template>
  <BFormTextarea
    @input="updateData"
    v-if="variant === 'textarea'"
    :placeholder="$t(placeholder)"
    :rows="rows"
    :disabled="disabled"
    :value="currentValue"
    :state="errors.length > 0 ? false : null"
  />
  <b-form-checkbox
    v-else-if="variant === 'switch'"
    @input="updateData"
    :disabled="disabled"
    :checked="currentValue"
    switch
  />
  <b-form-input
    v-else
    @input="updateData"
    :placeholder="$t(placeholder)"
    :disabled="disabled"
    :value="currentValue"
    :state="errors.length > 0 ? false : null"
  />
</template>
<style lang="scss">
.form-control.is-invalid {
  background-image: unset !important;
}
</style>
<script>
import { BFormInput, BFormTextarea, BFormGroup } from "bootstrap-vue";
import { ValidationProvider } from "vee-validate";

export default {
  name: "WidgetString",
  props: {
    rows: {
      type: Number,
      default: 6,
    },
    disabled: [Boolean, String, Number],
    variant: {
      type: String,
      validator: (value) => ["textarea", "switch", "input"].includes(value),
    },
    value: [String, Number,Boolean],
    placeholder: {
      type: String,
      default: "",
    },
    errors: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data: () => ({
    currentValue: "",
  }),
  methods: {
    updateData(v) {
      console.log(v,"655")
      this.$emit("input", v);
    },
  },
  watch: {
    value: {
      handler: function (v) {
        console.log(v,"722")
        this.currentValue = this.value;
      },
      deep: true,
    },
  },
  mounted() {
    if (this.value) {
      this.currentValue = this.value;
    }
  },

  components: {
    ValidationProvider,
    BFormInput,
    BFormGroup,
    BFormTextarea,
  },
};
</script>
